namespace TabAurous.Purchase {
    export namespace POSOrderItemsService {
        export const baseUrl = 'Purchase/POSOrderItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<OrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Purchase/POSOrderItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>POSOrderItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
